import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'NiotaClassicApplicationsAddDevice',
  props: {// applicationId: {
    //   type: Number,
    //   required: true,
    // },
  },
  data: function data() {
    return {
      deviceUpdateDialog: false,
      selectedRows: [],
      selected: [],
      editAllFormDialog: false,
      selectOriginatorStep: true,
      addNew: false,
      finalStep: false,
      editedItem: {
        applicationId: parseInt(this.$route.params.applicationId)
      },
      originators: [],
      deviceTypes: [],
      originatorListLimit: 50
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])),
  mounted: function mounted() {
    this.originatorFetchPlain();
  },
  destroyed: function destroyed() {
    this.$emit('close');
  },
  methods: {
    refreshList: function refreshList() {
      this.$emit('refreshList');
    },
    originatorFetchPlain: function originatorFetchPlain() {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      NiotaClassicApiService.originatorsFetchPlain(this.originatorListLimit).then(function (res) {
        _this.originators = res.data.originators;
      }).catch(function () {
        _this.originators = [];

        _this.$snack('Error fetching originators', 'error');
      }).finally(function () {
        _this.isFetching = false;
      });
    },
    selectedOriginator: function selectedOriginator(originator) {
      this.editedItem.originatorId = originator.id;
      this.originator = originator;
      this.datasourceType = this.originator.datasource.type;
      this.editedItem = cloneDeep(this.editedItem);
      this.selectOriginatorStep = false;
      this.finalStep = true;
      this.deviceTypeFetchPlain();
    },
    resetOriginator: function resetOriginator() {
      delete this.editedItem.originatorId;
      this.originator = {};
      this.datasourceType = null;
      this.editedItem = cloneDeep(this.editedItem);
      this.firstStep = false;
      this.selectOriginatorStep = true;
      this.finalStep = false;
      this.addNew = false;
    },
    resetApplication: function resetApplication() {
      delete this.editedItem.originatorId;
      delete this.editedItem.applicationId;
      this.originator = {};
      this.datasourceType = null;
      this.editedItem = cloneDeep(this.editedItem);
      this.selectOriginatorStep = false;
      this.finalStep = false;
    },
    deviceTypeFetchPlain: function deviceTypeFetchPlain() {
      var _this2 = this;

      NiotaClassicApiService.deviceTypeFetchPlain().then(function (res) {
        _this2.deviceTypes = res.data.devicetypes;
      }).catch(function () {
        _this2.deviceTypes = [];

        _this2.$snack(_this2.$i18n_t('NiotaClassic.Applications.form.errorFindingOriginators'), 'error');
      });
    }
  }
};